import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useStoreActions } from '~/contexts';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useTasksJobs } from '../hooks/useTasksJobs';
export function useCancelTask() {
    const { api } = useStoreActions();
    const { optimisticUpdate } = useTasksJobs({
        enabled: false
    });
    const { mutate } = useMutationState({
        mutationFn: (param)=>{
            let { jobId } = param;
            return api.jobs.cancelJob(jobId);
        },
        onMutate: (param)=>{
            let { jobId } = param;
            optimisticUpdate((tasks)=>tasks.map((t)=>t.jobId === jobId ? _object_spread_props(_object_spread({}, t), {
                        cancelling: true
                    }) : t));
        },
        onSuccess: (_d, param)=>{
            let { jobId } = param;
            optimisticUpdate((tasks)=>tasks.filter((t)=>t.jobId !== jobId));
        },
        onError: (_e, param)=>{
            let { jobId } = param;
            optimisticUpdate((tasks)=>tasks.map((t)=>t.jobId === jobId ? _object_spread_props(_object_spread({}, t), {
                        cancelling: false
                    }) : t));
        }
    });
    return {
        cancelTask: (jobId)=>mutate({
                jobId
            })
    };
}
